import { Box, DashboardModule, Text } from '@domain-group/suit-theme'

import { digObject, formatDate } from '@domain-group/javascript-utils'

import PublicationEditionHeader from '@components/PublicationEditionHeader'

import usePublicationEdition from '@hooks/usePublicationEdition'

import AgencyGroup from './AgencyGroup'

interface PublicationInspectionGroupProps {
  entityCount: number,
  agencyGroups: object,
  publicationEditionId: number,
}

const PublicationInspectionGroup = (props: PublicationInspectionGroupProps) => {
  const {
    entityCount, agencyGroups, publicationEditionId,
  } = props

  const { publication, publicationEdition } = usePublicationEdition({ id: publicationEditionId })

  const secondaryText = entityCount === 1 ? '1 Inspection' : `${entityCount} Inspections`

  const inspectionDeadline = digObject(publicationEdition, 'dates.inspection.date_time', '')
  const formattedDeadline = formatDate(inspectionDeadline, 'dd/MM/yyyy HH:mm', "ccc dd LLL y 'at' h:mma")

  return (
    <DashboardModule
      customHeader={(
        <PublicationEditionHeader
          publicationEdition={publicationEdition}
          // @ts-expect-error TS2339
          publicationTitle={publication?.title}
        >
          <Text color="faintGrey" fontSize="small" marginBottom="small">
            {secondaryText}
          </Text>

          <PublicationEditionHeader.Deadline deadline={formattedDeadline} />
        </PublicationEditionHeader>
      )}
    >
      <Box flexDirection="column">
        {Object.values(agencyGroups).map((agencyGroup, i, arr) => (
          <AgencyGroup
            agencyGroup={agencyGroup}
            // @ts-expect-error TS2322
            isLastGroup={arr.length - 1 === i}
            key={agencyGroup.id}
            publicationEditionId={publicationEditionId}
          />
        ))}
      </Box>
    </DashboardModule>
  )
}

export default PublicationInspectionGroup
